var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('consumption-data-exchange',{attrs:{"type":_vm.type,"customer-id":_vm.customerId}})}
var staticRenderFns = []

export { render, staticRenderFns }